module.exports = __webpack_public_path__ + "assets/webgl/card_080_DE_L0.fc0e63a5.jpg";